<template>
  <v-container>
    <v-main>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="8" lg="5">
          <h1 class="text-center">Deeplink Test</h1>
          <br />
          <v-btn block color="primary" :href="linkEps"
            >Račun za električnu energiju</v-btn
          ><br />
          <v-btn block color="primary" :href="linkKomunalije"
            >Račun za komunalne usluge</v-btn
          ><br />
          <v-btn block color="primary" :href="linkPorez">Porez na imovinu</v-btn
          ><br />
          <v-btn block color="primary" :href="linkMts"
            >Račun za MTS usluge</v-btn
          >
        </v-col>
      </v-row>
    </v-main>
  </v-container>
</template>
<script>
require("dotenv/config");

export default {
  data() {
    return {
      linkEps: process.env.VUE_APP_DEEPLINK_EPS,
      linkKomunalije: process.env.VUE_APP_DEEPLINK_KOMUNALIJE,
      linkPorez: process.env.VUE_APP_DEEPLINK_POREZ,
      linkMts: process.env.VUE_APP_DEEPLINK_MTS
    };
  }
};
</script>
<style scoped></style>
